import React, { useRef, useState } from 'react';
import { Navigate, Link } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import Button from '../../components/common/Button/Button';
import cosmicLogo from '../../assets/images/cosmic-logo.png';
import styles from './Login.module.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated, user, getRedirectPath } = useAuth();

  // Bounce users who are already signed in when they land on /login.
  // But once a sign-in has been submitted HERE, AuthContext.login() owns the
  // redirect (so it can honour a saved deep-link target) — this component
  // must not race it with its own <Navigate>.
  const submittedHere = useRef(false);

  if (isAuthenticated && user && !submittedHere.current) {
    return <Navigate to={getRedirectPath(user)} replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    submittedHere.current = true;

    const result = await login(email, password);
    
    if (!result.success) {
      submittedHere.current = false;
      setError(result.error);
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginCard}>
        <div className={styles.header}>
          <img src={cosmicLogo} alt="COSMIC Logo" className={styles.logoImage} />
          <h1 className={styles.logo}>COSMIC</h1>
          <p className={styles.subtitle}>CreatED's Orbit for Strategic Mentor Incubation and Coordination</p>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.formGroup}>
            <label htmlFor="email" className={styles.label}>Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={styles.input}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="password" className={styles.label}>Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={styles.input}
              placeholder="Enter your password"
              required
            />
          </div>

          {error && (
            <div className={styles.error}>
              {error}
            </div>
          )}

          <Button type="submit" loading={loading}
            variant="primary"
            fullWidth
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </Button>
        </form>

        <div className={styles.footer}>
          <p>
            <Link to="/forgot-password" style={{ color: '#4a90e2' }}>Forgot your password?</Link>
          </p>
          <p style={{ marginTop: '10px' }}>
            Don't have an account? <Link to="/register" style={{ color: '#4a90e2' }}>Register here</Link>
          </p>
          <p style={{ marginTop: '10px' }}>© 2025 CreatED. All rights reserved.</p>
          <p style={{ marginTop: '8px', fontSize: '11px', color: '#666' }}>
            Dev Team: {' '}
            <a 
              href="https://www.linkedin.com/in/sankar4/" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: '#0077b5', textDecoration: 'none' }}
            >
              Sankar Balasubramanian
            </a>
            {' & '}
            <a 
              href="https://www.linkedin.com/in/aashna-saraf-324463166/" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: '#0077b5', textDecoration: 'none' }}
            >
              Aashna Saraf
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;